
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class FormatMasterDialog extends Serenity.EntityDialog<FormatMasterRow, any> {
        protected getFormKey() { return FormatMasterForm.formKey; }
        protected getIdProperty() { return FormatMasterRow.idProperty; }
        protected getLocalTextPrefix() { return FormatMasterRow.localTextPrefix; }
        protected getNameProperty() { return FormatMasterRow.nameProperty; }
        protected getService() { return FormatMasterService.baseUrl; }
        protected getDeletePermission() { return FormatMasterRow.deletePermission; }
        protected getInsertPermission() { return FormatMasterRow.insertPermission; }
        protected getUpdatePermission() { return FormatMasterRow.updatePermission; }
        public newformat = "";
        public string1 = ""; string2 = ""; string3 = ""; string4 = ""; string5 = ""; string6 = ""; designprefix = ""; designsuffix = ""; separator = ""; designdate = "";
        protected form = new FormatMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.FormatType.changeSelect2(e => {
                var type = this.form.FormatType.value;
                if (type == "POSCustomer" || type == "Employee") {
                    q.showAndSetRequiredField(this.form.Prefix);
                    q.showAndSetRequiredField(this.form.Separator);
                } else {
                    q.showAndSetRequiredField(this.form.Prefix);
                    q.showAndSetRequiredField(this.form.Separator);
                }

                if (type == "SKU") {
                    q.showAndEnableField(this.form.PrefixCode);
                }
                else {
                    q.hideField(this.form.PrefixCode)
                }
                if (type == "RefNo") {
                    Serenity.EditorUtils.setRequired(this.form.Separator, false);
                } else
                    q.showAndSetRequiredField(this.form.Separator);
            })
            this.form.CounterWise.changeSelect2(e => {
                if (this.form.CounterWise.value == true) {
                    var x = this.generatenewformat("COUNTER", 2);
                    this.form.Format.value = x;
                } else {
                    var x = this.generatenewformat("", 2);
                    this.form.Format.value = x;
                }
            });
            this.form.BranchWise.changeSelect2(e => {
                if (this.form.BranchWise.value == true) {
                    var x = this.generatenewformat("BRANCH", 1);
                    this.form.Format.value = x;
                } else {
                    var x = this.generatenewformat("", 1);
                    this.form.Format.value = x;
                }
            });
            this.form.Prefix.changeSelect2(e => {

                var x = this.generatenewformat(this.form.Prefix.value, 3);
                this.form.Format.value = x;
            });
            this.form.PrefixDate.changeSelect2(e => {
                var type = this.form.FormatType.value;
                if (type == "Design") {
                    var x = this.generatenewformat(this.form.PrefixDate.value, 10);
                    this.form.Format.value = x;
                } else {
                    var x = this.generatenewformat(this.form.PrefixDate.value, 4);
                    this.form.Format.value = x;
                }
            });
            this.form.Suffix.changeSelect2(e => {
                var x = this.generatenewformat(this.form.Suffix.value, 5);
                this.form.Format.value = x;
            });
            this.form.LastNumber.changeSelect2(e => {
                var x = this.generatenewformat(this.form.LastNumber.value, 6);
                this.form.Format.value = x;
            });
            this.form.Separator.changeSelect2(e => {
                var x = this.generatenewformat(this.form.Separator.value, 7);
                this.form.Format.value = x;
            });
            this.form.PrefillwithZero.changeSelect2(e => {
                if (this.form.PrefillwithZero.value == true) {
                    Serenity.EditorUtils.setReadonly(this.form.Noofzeroes.element, false);
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Noofzeroes.element, true);
                }

            });
            this.form.FormatType.changeSelect2(e => {

                var type = this.form.FormatType.value;
                if (type == "POSCustomer" || type == "SKU") {
                    Serenity.EditorUtils.setRequired(this.form.Prefix, false);
                    Serenity.EditorUtils.setRequired(this.form.Separator, false);
                    Serenity.EditorUtils.setRequired(this.form.PrefixDate, false);
                    Serenity.EditorUtils.setRequired(this.form.StartIndex, false);
                }
                if (type == "Design") {
                    q.hideField(this.form.Prefix);
                    q.hideField(this.form.PrefixCode);
                    q.hideField(this.form.Suffix);;
                    q.showAndDisableField(this.form.Separator);
                } else {
                    q.showAndEnableField(this.form.DesignPrefixEditor);
                    q.showAndEnableField(this.form.PrefixCode);
                    q.showAndEnableField(this.form.DesignSuffixEditor);
                    q.showAndEnableField(this.form.Separator);
                    q.showAndSetRequiredField(this.form.Separator);
                }
            });

            this.form.ResetMonthly.changeSelect2(e => {
                this.form.LastMonth.value = new Date().getMonth() + 1;

            });

            this.form.ResetYearly.changeSelect2(e => {
                this.form.LastYear.value = new Date().getFullYear();

            });

            this.form.DesignPrefixEditor.changeSelect2(e => {
                var x = this.generatenewformat(this.form.DesignPrefix.value, 8);
                this.form.Format.value = x;
            });
            this.form.DesignSuffixEditor.changeSelect2(e => {
                var x = this.generatenewformat(this.form.DesignSuffix.value, 9);
                this.form.Format.value = x;
            });
        }
        protected onDialogOpen() {
            this.newformat = this.form.Format.value;
            this.separator = this.form.Separator.value;
            if (this.form.BranchWise.value == true) {
                this.string1 = "[BRANCH]";
                if (this.form.CounterWise.value == true) {
                    this.string1 = "[BRANCH]" + this.separator;
                }
            }
            if (this.form.CounterWise.value == true) {
                this.string2 = "[COUNTER]";
                if (this.form.Prefix.value != "") {
                    this.string2 = "[COUNTER]" + this.separator;
                }
            }
            if (this.form.Prefix.value != "") {
                this.string3 = "[" + this.form.Prefix.value + "]" + this.separator;
            }
            if (this.form.PrefixDate.value != "") {
                this.string4 = this.form.PrefixDate.value;
                if (this.form.Suffix.value != "") {
                    this.string4 = this.form.PrefixDate.value + this.separator;
                }
            }
            if (this.form.Suffix.value != "") {
                this.string5 = "[" + this.form.Suffix.value + "]";
                if (this.form.LastNumber.value.toString() != "") {
                    this.string5 = "[" + this.form.Suffix.value + "]" + this.separator;
                }
            }
            if (this.form.LastNumber.value != parseInt("") && this.form.LastNumber.value != null) {
                this.string6 = "[" + this.form.LastNumber.value.toString() + "]";
            }
            this.separator = this.form.Separator.value;

            var type = this.form.FormatType.value;
            if (type == "POSCustomer" || type == "SKU") {
                Serenity.EditorUtils.setRequired(this.form.Prefix, false);
                Serenity.EditorUtils.setRequired(this.form.Separator, false);
                Serenity.EditorUtils.setRequired(this.form.PrefixDate, false);
                Serenity.EditorUtils.setRequired(this.form.StartIndex, false);
            }
            if (type == "Design") {
                q.hideField(this.form.Prefix);
                q.hideField(this.form.PrefixCode);
                q.hideField(this.form.Suffix);
                q.hideField(this.form.Separator);
                q.showAndDisableField(this.form.Separator);
            } else {
                q.showAndEnableField(this.form.DesignPrefixEditor);
                q.showAndEnableField(this.form.PrefixCode);
                q.showAndEnableField(this.form.DesignSuffixEditor);
                q.showAndEnableField(this.form.Separator);
                q.showAndSetRequiredField(this.form.Separator);
            }

            var designsuffix = this.form.DesignSuffixEditor.value;
            if (designsuffix == "") {
                var option1: Serenity.Select2Item = {
                    id: "Karat", text: "Karat", source: { id: "Karat", text: "Karat" }
                };
                var option2: Serenity.Select2Item = {
                    id: "MetalColor", text: "Metal Color", source: { id: "MetalColor", text: "Metal Color" }
                };
                var option3: Serenity.Select2Item = {
                    id: "MappingId", text: "Mapping", source: { id: "MappingId", text: "Mapping" }
                };
                var option4: Serenity.Select2Item = {

                    id: "ProductSizeId", text: "Product Size", source: { id: "ProductSizeId", text: "Product Size" }
                };
                var option5: Serenity.Select2Item = {
                    id: "CustomerCode", text: "Customer Code", source: { id: "CustomerCode", text: "Customer Code" }
                };
                var option6: Serenity.Select2Item = {
                    id: "Category", text: "Category", source: { id: "Category", text: "Category" }
                };
                var items = [];
                items.push(option1);
                items.push(option2);
                items.push(option3);
                items.push(option4);
                items.push(option5);
                items.push(option6);
                this.form.DesignPrefixEditor.setSelect2Items(items);
                this.form.DesignSuffixEditor.setSelect2Items(items);
            }
            if (this.form.DesignSuffix.value != "") {
                this.form.DesignPrefixEditor.items = items;
                this.form.DesignSuffixEditor.items = items;
            }
        }
        private generatenewformat(value, position) {
            this.separator = this.form.Separator.value;
            switch (position) {
                case 1:
                    if (value != "") {
                        this.string1 = "[" + value + "]" + this.separator;
                    } else
                        this.string1 = ""
                    break;
                case 2:
                    if (value != "") {
                        this.string2 = "[" + value + "]" + this.separator;
                    } else
                        this.string2 = ""
                    break;
                case 3:
                    if (value != "") {
                        this.string3 = "[" + value + "]" + this.separator;
                    } else
                        this.string3 = ""
                    break;
                case 4:
                    if (value != "") {
                        this.string4 = value + this.separator;
                    } else
                        this.string4 = ""
                    break;
                case 5:
                    if (value != "") {
                        this.string5 = "[" + value + "]" + this.separator;
                    } else
                        this.string5 = ""
                    break;
                case 6:
                    if (value != "") {
                        this.string6 = "[" + value + "]";
                    } else
                        this.string6 = ""
                    break;
                case 7:
                    if (this.separator == "/") {
                        let re = /\-/gi;
                        this.newformat = this.newformat.replace(re, "/");
                    } else if (this.separator == "-") {
                        //alert(this.string4);
                        if (this.string4 == "[MM]/[YY]" + this.separator || this.string4 == "[MM]/[YY]") {
                            this.newformat = this.newformat.replace("M]/[Y", "M]_[Y");
                        }
                        else if (this.string4 == "[MON]/[YYYY]" || this.string4 == "[MON]/[YYYY]" + this.separator) {
                            this.newformat = this.newformat.replace("N]/[Y", "N]_[Y");
                        }
                        let re = /\//gi;
                        this.newformat = this.newformat.replace(re, "-");
                        this.newformat = this.newformat.replace("]_[", "/");
                    }
                    break;

                case 8:
                    var prefixdesign = this.form.DesignPrefixEditor.selectedItems;
                    var separator = this.form.Separator.value;
                    this.designprefix = "";
                    if (prefixdesign != null && prefixdesign.length > 0) {
                        for (var i = 0; i < prefixdesign.length; i++) {
                            if (i == 0)
                                this.designprefix += prefixdesign[i].text;
                            else if (i > 0)
                                this.designprefix += separator + prefixdesign[i].text;

                        }

                    }
                    break;
                case 9:
                    var suffixdesign = this.form.DesignSuffixEditor.selectedItems;
                    var separator = this.form.Separator.value;
                    this.designsuffix = "";
                    if (suffixdesign != null && suffixdesign.length > 0) {
                        for (var i = 0; i < suffixdesign.length; i++) {
                            this.designsuffix += separator + suffixdesign[i].text;
                        }

                    }
                    break;
                case 10:
                    if (value != "") {
                        this.designdate = value + this.separator;
                    } else
                        this.designdate = ""
                    break;
            }
            if (position != 7) {
                this.newformat = this.string1 + this.string2 + this.string3 + this.string4 + this.string5 + this.string6;
            }
            if (position == 8 || position == 9 || position == 10) {
                this.newformat = this.designprefix + this.separator + this.designdate + this.designsuffix;
            }
            return this.newformat;
        }
        protected validateBeforeSave() {
            var isValid = super.validateBeforeSave();

            let designprefix = this.form.DesignPrefixEditor.selectedItems;

            let designsuffix = this.form.DesignSuffixEditor.selectedItems;

            for (let i = 0; i < designprefix.length; i++) {
                var prefix = designprefix[i];
                for (let j = 0; j < designsuffix.length; j++) {
                    let suffix = designsuffix[j];
                    if (prefix == suffix) {
                        q.alert('', 'Design Suffix/Prefix have similar options' + suffix, true, 3000);
                        isValid = false;
                        return isValid;
                    }
                }

            }
            if (isValid) {
                var temp = "";
                var separator = this.form.Separator.value;
                for (var i = 0; i < designprefix.length; i++) {
                    if (i == 0)
                        temp += designprefix[i].text;
                    else if (i > 1)
                        temp += separator + designprefix[i].text;
                }
                this.form.DesignPrefix.value = temp;


                var temp = "";
                var separator = this.form.Separator.value;
                for (var i = 0; i < designsuffix.length; i++) {
                    if (i == 0)
                        temp += designsuffix[i].text;
                    else if (i > 1)
                        temp += separator + designsuffix[i].text;
                }
                this.form.DesignSuffix.value = temp;
            }
            return isValid;
        }
    }
}